class ArticleContent extends HTMLElement {
    constructor() {
        super();
        this.swiper    = this.querySelector('[data-swipe]');
        this.vidX      = this.getAttribute('videoWidth');
        this.vidY      = this.getAttribute('videoHeight');
        this.slidesPer = this.getAttribute('slidesPerView');
        this.spaceBtwn = this.getAttribute('spaceBetween');
        this.speed     = this.getAttribute('autoPlaySpeed');
        this.slideFx   = this.getAttribute('slideEffect');
    }

    connectedCallback() {
        this.changeEmbededVideoSize();
        if (document.readyState === 'complete') {
            this.initSwiper();
        } else {
            window.addEventListener('load', () => {
                this.initSwiper();
            });
        }
    }

    changeEmbededVideoSize() {
        const postIframes = this.querySelectorAll('iframe');
        const iframes = [...postIframes].map((a) => {
            if (a.src.includes('youtube')) {
                a.attributes.width.value = this.vidX;
                a.attributes.height.value = this.vidY;
            }
        });
    }

    initSwiper() {
        this.slider = new Swiper(this.swiper, {
            effect: this.slideFx,
            slidesPerView: this.slidesPer,
            spaceBetween: parseInt(this.spaceBtwn),
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: true,
            autoplay: {
                delay: this.speed,
            }
        });
    }
}

customElements.define('article-content', ArticleContent);